import store from "@/store";
import AdminPage from "@/Pages/AdminPage/index.vue";
import ListarUsuariosPage from "@/Pages/AdminPage/Usuarios/ListarUsuariosPage.vue";
import HomePage from "@/Pages/HomePage/index.vue";
import LoginPage from "@/Pages/LoginPage/index.vue";
import ResetPasswordPage from "@/Pages/LoginPage/ResetPasswordPage.vue";
import LogoutPage from "@/Pages/LogoutPage.vue";
import Vue from "vue";
import VueRouter from "vue-router";

import authService from "../Services/AuthService";
import franquias from "./franquias";
import usuarios from "./usuarios";
import colaboradores from "./colaboradores";
import relatorios from "./relatorios";
import calendarioLetivo from "./calendario-letivo";
import eventosCalendarioLetivo from "./eventos-calendario-letivo";
import chat from "./chat";
import novidades from "./novidades";
import administracao from "./administracao";
import NaoAutorizado from "../Pages/NaoAutorizado.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "login" },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    beforeEnter(target, from, next) {
      if (authService.isLoggedIn()) {
        return next({ name: "home" });
      }
      return next();
    },
  },
  {
    path: "/home",
    name: "home",
    component: HomePage,
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: ResetPasswordPage,
    beforeEnter(target, from, next) {
      if (authService.isLoggedIn()) {
        return next({ name: "home" });
      }
      return next();
    },
  },
  {
    // Link enviado por e-mail: /redefinir-senha?token=...&login=...
    path: "/redefinir-senha",
    name: "redefinirSenha",
    component: ResetPasswordPage,
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminPage,
    beforeEnter(to, from, next) {
      return next({ name: "home" });
    },
  },
  {
    path: "/admin/usuarios/listar",
    name: "admin.usuarios.listar",
    component: ListarUsuariosPage,
    beforeEnter(to, from, next) {
      return next({ name: "home" });
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: LogoutPage,
  },
  {
    path: "/nao-autorizado",
    name: "NaoAutorizado",
    component: NaoAutorizado,
  },
  ...franquias,
  ...usuarios,
  ...colaboradores,
  ...relatorios,
  ...calendarioLetivo,
  ...eventosCalendarioLetivo,
  ...chat,
  ...novidades,
  ...administracao,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const rotasPublicas = ["login", "resetPassword", "redefinirSenha"];
  if (!rotasPublicas.includes(to.name) && !authService.isLoggedIn()) {
    return next({
      name: "login",
      query: {
        redirect: to.fullPath,
        name: to.name,
      },
    });
  }
  if (authService.isLoggedIn() && !store.getters["Auth/user"]) {
    try {
      await authService.syncUserWithStore();
    } catch (e) {
      // ignore
    }
  }
  return next();
});

export default router;
